import { Star } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getInitials } from '@/lib/utils';

const testimonials = [
  {
    name: 'Rajesh Kumar',
    role: 'Owner, TechMart',
    content: 'SparkCommerce transformed our WhatsApp sales. The AI handles 80% of customer queries automatically, and our order processing time dropped by 60%.',
    rating: 5,
    avatar: null,
  },
  {
    name: 'Priya Sharma',
    role: 'Founder, Fashion Studio',
    content: 'The POS system is incredibly fast and the WhatsApp integration is seamless. Our customers love receiving instant order confirmations and invoices.',
    rating: 5,
    avatar: null,
  },
  {
    name: 'Amit Patel',
    role: 'CEO, ElectroZone',
    content: 'We went from managing orders in Excel to a fully automated system. The inventory alerts alone have saved us from countless stockouts.',
    rating: 5,
    avatar: null,
  },
];

export function Testimonials() {
  return (
    <section className="py-20 lg:py-32 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Loved by{' '}
            <span className="gradient-text">Businesses</span>{' '}
            Everywhere
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands of businesses that are growing with SparkCommerce
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.name}
              className="p-6 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" />
                ))}
              </div>

              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3">
                <Avatar>
                  <AvatarImage src={testimonial.avatar} />
                  <AvatarFallback className="bg-primary/10 text-primary">
                    {getInitials(testimonial.name)}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="font-semibold text-sm">{testimonial.name}</p>
                  <p className="text-muted-foreground text-xs">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
